/** 关键词文本 ↔ 数组（T07）：世界书关键词用逗号分隔输入。 */

/**
 * 把逗号分隔的关键词文本切成数组（中英文逗号均可），自动去空白与空项。
 * 例：`"喵, 猫，狗"` → `['喵', '猫', '狗']`
 */
export function splitKeywords(text: string): string[] {
  return text
    .split(/[,，]/)
    .map((item) => item.trim())
    .filter((item) => item !== '');
}